/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_PhotoInputs */

const en_history_photo = /** @type {(inputs: History_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

const de_history_photo = /** @type {(inputs: History_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {History_PhotoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_photo = /** @type {((inputs?: History_PhotoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_PhotoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_photo(inputs)
	return en_history_photo(inputs)
});